import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=2bb55b2a"
import script from "./WorkPlace.vue?vue&type=script&lang=js"
export * from "./WorkPlace.vue?vue&type=script&lang=js"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=2bb55b2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports